import { pxToEm } from 'util/pxToEm';
import React, { ReactElement } from 'react';

import { SplashFormLayout } from 'layouts';
import { Box, Typography } from '@mui/material';

import { SignUpForm } from 'components/forms';
import { Routes } from 'services/routes';
import { useRouter } from 'next/router';

export interface SignupProps {}

export default function SignupPage(_props: SignupProps): ReactElement {
  const router = useRouter();

  return (
    <SplashFormLayout>
      <Box width="100%" overflow="visible">
        <Box>
          <Typography
            variant="h2"
            sx={{
              fontSize: 30,
              fontWeight: 500,
              color: '#000',
            }}
          >
            Create Account
          </Typography>
        </Box>

        <SignUpForm />

        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
        >
          <Box pr={10}>
            <Typography sx={{ fontSize: pxToEm(16), fontWeight: 500 }}>
              Already have an account?
            </Typography>
          </Box>
          <Typography
            sx={{
              fontSize: pxToEm(14),
              textDecoration: 'underline',
              '&:hover': {
                cursor: 'pointer',
              },
            }}
            onClick={() => {
              void router.push(Routes.logIn());
            }}
          >
            Log In Today
          </Typography>
        </Box>
      </Box>
    </SplashFormLayout>
  );
}
